export const enableCANDefinitions = [
  {
    value: "true",
    details: "Xirgocam will read CAN bus data from the vehicle"
  },
  {
    value: "false",
    details: "Xirgocam will NOT read CAN bus data from the vehicle"
  }
]